  <script lang="ts">
	//import {ASSET_URL} from "../config";
	import FileUploadBtn from "./FileUploadBtn.svelte";
	import UploadInfoBox from "./UploadInfoBox.svelte";
	import {myStore, entityStore} from "../../stores.js";

	export let title = null;

	export let disabled = false;

</script>

 <div class="community-data-box" style="padding-top:1.8rem">

	 {#if title}
	 <div class="box-header">
		 <h4>{title}</h4>
	 </div>
	 {/if}
	 <div class="box-content">

		 <div>
			 <div class="info-text-box"></div>

			 <div class="custom-col-12">
				 <UploadInfoBox
						 text="Lettre signée par le·la·les bourgmestre·s et le·la·les président·e·s de la·des commission·s communale·s du vivre-ensemble interculturel motivant l’adhésion au pacte communal et demandant les subventions y liées"
						 overlayText="Veuillez décrire en quelques phrases ce qui motive votre commune ou votre groupe de communes à signer le pacte communal du vivre-ensemble interculturel et les objectifs clés que vous poursuivrez dans le cadre de sa mise en œuvre. Veuillez également indiquer si et, le cas échéant, lesquelles des subventions liées au pacte communal vous souhaitez solliciter."
				 ></UploadInfoBox>
			 </div>


		<!-- old version
		 <textarea class="custom-col-12" rows="10"
				   class:error={$myStore.errors.step2.applicationChairmanText}
				 name="step2.applicationChairmanText"  placeholder="Lettre signée par le bourgmestre et le président de la commission communale motivant l’adhésion au pacte communal et demandant les subventions y liées*"></textarea>
		 </div>
		 -->

		 </div>

	 <div class="mt-3">
		 <FileUploadBtn {disabled} fieldName="step2.applicationChairmanFiles" errorClass={$myStore.errors.step2?.applicationChairmanFiles}></FileUploadBtn>
	 </div>

	 	<div class="box-divider"></div>

	 <div>
		 <!--
		 <textarea class="custom-col-12" rows="10" class:error={$myStore.errors.step2.applicationPersonText}
				   name="step2.applicationPersonText"   placeholder="Lettre signée par le bourgmestre et le président de la commission communale motivant l’adhésion au pacte communal et demandant les subventions y liées*"></textarea>
	 	-->

		 <div class="custom-col-12">
			 <UploadInfoBox
					 text="Liste des représentant·e·s de toutes les communes participantes proposé·e·s pour être membre du comité de pilotage (voir dispositions de l'Article 6(5) de la loi relative au vivre-ensemble interculturel)"
					>

				 <span slot="overlayText">
					Selon l'Article 6(5) de la loi relative au vivre-ensemble interculturel, le comité de pilotage du pacte communal est composé d'au moins cinq membres, dont:<br><br>
					1° un membre du conseil communal;<br>
					2° deux membres de la commission communale, autres que le membre du conseil communal visé au point 1°;<br>
					3° deux membres des associations locales<br>
					4° le·la coordinateur·trice pacte communal dans les communes qui en disposent.
				 </span>
			 </UploadInfoBox>
		 </div>

	 </div>

	 <div class="mt-3">
		 <FileUploadBtn {disabled} fieldName="step2.applicationPersonFiles" errorClass={$myStore.errors.step2?.applicationPersonFiles}></FileUploadBtn>
	 </div>

	 </div>

 </div>


<style lang="scss">

	.box-divider{

		margin-top:1.5rem;
		border-bottom:1px solid $form-item-bg;
		margin-bottom:1.5rem;
	}

	.community-data-box{

		background:$secondary-color;
		padding:1.5rem;
		border-radius:9px;
		color: #F8F7F7!important;
		flex:1;


		.box-header{

			h4{
				margin:0;
				padding:0;
			}

			margin-bottom:1rem;

		}
	}


</style>
